import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import ncMedallion from "@/assets/nc-medallion.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/radio", label: "Podcast" },
  { to: "/music", label: "Music" },
  { to: "/about", label: "About" },
  { to: "/epk", label: "EPK & Booking" },
  { to: "/inspire", label: "Inspire Da Streets" },
  { to: "/chronicles", label: "Chronicles" },
  { to: "/fan-club", label: "Fan Club" },
  { to: "/backstage", label: "Backstage" },
  { to: "/shop", label: "Shop" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="glass-nav fixed top-0 inset-x-0 z-50"
      data-testid="site-navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="group inline-flex items-center gap-2.5 font-serif text-xl tracking-tighter text-white"
          data-testid="nav-logo"
        >
          <img
            src={ncMedallion}
            alt="Nina Capone crest"
            width={40}
            height={40}
            className="h-9 w-9 rounded-full ring-1 ring-[color:var(--gold)]/40 shadow-[0_0_16px_rgba(232,180,196,0.35)] transition-transform duration-300 group-hover:scale-105"
            data-testid="nav-logo-medallion"
          />
          <span>
            NINA <span style={{ color: "var(--gold)" }}>CAPONE</span>
            <sup className="align-super text-[0.45em] tracking-normal font-normal opacity-80 ml-0.5">™</sup>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8 text-sm">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <a
          href="https://open.spotify.com/album/2XDRxKesvCeCc6oS4dfX3g?si=O4VMDHl0T_K3rdG3-oHpfA"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2 text-xs btn-gold rounded-none"
          data-testid="nav-listen-live"
        >
          <span className="inline-block w-1.5 h-1.5 bg-black rounded-full live-dot" />
          Listen Live
        </a>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 px-6 py-6 space-y-4 bg-[#050308]/95">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block text-base ${isActive ? "text-[color:var(--gold)]" : "text-white/70"}`
              }
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href="https://open.spotify.com/album/2XDRxKesvCeCc6oS4dfX3g?si=O4VMDHl0T_K3rdG3-oHpfA"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="inline-flex px-5 py-2 text-xs btn-gold rounded-none"
            data-testid="mobile-nav-listen-live"
          >
            Listen Live
          </a>
        </div>
      )}
    </header>
  );
}
